import { render, staticRenderFns } from "./Offerwalls.vue?vue&type=template&id=66830772&"
import script from "./Offerwalls.vue?vue&type=script&lang=js&"
export * from "./Offerwalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports